export const GET_FEATURED_NEWS_START = "GET_FEATURED_NEWS_START", 
GET_FEATURED_NEWS_SUCCESS = "GET_FEATURED_NEWS_SUCCESS", 
GET_FEATURED_NEWS_FAIL = "GET_FEATURED_NEWS_FAIL";